import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  Injector,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PageHeaderComponentModel } from '@app/shared/interfaces/page-header-component-model';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { Product } from '@product/shared/models/product';
import { Category } from '@app/shared/interfaces/Category';
import { HardCopy } from 'src/global-variables';
import { DropDownOption } from '@product/shared/models/GlobalInterfaces';
import { Translation } from '@app/shared/interfaces/Translation';
import { EMPTY, of, switchMap } from 'rxjs';

@Component({
  selector: 'app-form-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.less'],
})
export class FormCategoryComponent extends BaseComponent implements OnInit {
  _formGroup: FormGroup = new FormGroup({});
  @Input() set formGroup(formGroup: FormGroup) {
    this._formGroup = formGroup;
    setTimeout(() => {
      if (this.languages.length > 0) {
        this.initTranslationGroup();
      }
    }, 1000);
    if (formGroup.value.ProductCategories != null) {
      this.getRelatedProducts(formGroup.value.ProductCategories);
    }
  }
  get formGroup() {
    return this._formGroup;
  }

  @Input() mode: string;
  @Input() categories: Category[] = [];
  @Input() componentModel: PageHeaderComponentModel;
  @Input() categoryId: number = 0;
  @Output() submitChanges: EventEmitter<any> = new EventEmitter();
  @Output() attributeGroupsLoaded = new EventEmitter();
  @Output() listPayload = new EventEmitter<any>();
  record: any;
  relatedProducts: any[] = [];
  languages: DropDownOption[] = [];
  isLoad: boolean = false;
  constructor(injector: Injector) {
    super(injector);
  }
  categoryForm: FormGroup;
  isLanguagesLoading: boolean = false;
  catalogMode: string = '';
  //  ngOnChanges(changes: SimpleChanges) {
  //     if (changes['categoryId']) {
  //       this.categoryId=this.categoryId;
  //     }
  //   }

  ngOnInit(): void {
    // this.tabIndex= localStorage.getItem('tabIndex') || 'Manual';
    // this.languages = this.commonService.dropDownMetaData['languages'].filter(
    //   (x) => x.Code !== 0
    // );
    this.initializeData();


  }
  initializeData() {
    this.isLanguagesLoading = true;
    try {
      const allLanguages = this.commonService.dropDownMetaData['languages'];
      this.languages = allLanguages.filter((x) => x.Code !== 0);
    } catch (error) {
      console.error('Error loading languages:', error);
    } finally {
      this.isLanguagesLoading = false;
    }

    const productCategoriesControl = this.formGroup.get('ProductCategories');
    if (productCategoriesControl != null) {
      this.subscriptions.push(
        productCategoriesControl.valueChanges.subscribe((categories) => {
          if (categories != null) {
            this.getRelatedProducts(categories);
          }
        })
      );
    }
  }
  override submit() {

    super.submit();
    this.submitChanges.emit();
  }
  onAttributeGroupsLoaded(groups: any[]) {
    this.attributeGroupsLoaded.emit(groups);
  }
  
  recordLoaded(record: any) {
    this.isLoad = true;
    this.catalogMode = 'edit';
    this.record = record;
    this.tabIndex = record.Type;
    this.categories = this.categories.filter((x) => x.Id !== record.Id);
    if (
      this.record.ClonedCategories != null &&
      this.record.ClonedCategories.length > 0
    ) {
      const Ids = (this.record.ClonedCategories as Category[]).map((x) => x.Id);
      this.formGroup.get('ClonedCategories')?.setValue(Ids);
    }
    if (this.record.Translations) {
      const pureTranslations = this.record.Translations as Translation[];
      let handledTranslations: Record<string, string> = {};
      pureTranslations.forEach((trns) => {
        handledTranslations[trns.LanguageId.toString()] = trns.Label;
      });
      this.record.Translations = handledTranslations;
      this.formGroup.get('Translations')?.patchValue(handledTranslations);
    }
    setTimeout(() => {
      this.isLoad = false;
    }, 100);

  }

  cleanRecord(record: any): any {
    return record;
  }

  beforeSubmit() {
    this.formGroup.get('type')?.setValue(this.tabIndex);
    const ids = this.formGroup.get('ClonedCategories')?.value as number[];
    const category = HardCopy(this.formGroup.getRawValue());
    if (ids != null) {
      const categories = this.categories.filter((cat) => ids.includes(cat.Id!));
      category.ClonedCategories = categories;
    } else {
      delete category.ClonedCategories;
    }
    this.listPayload.emit(this.filter);
   
    return category;

  }

  getRelatedProducts(productCategories: any[]) {
    if (productCategories == null) {
      return;
    }
    let ids = productCategories.map((x) => {
      if (!isNaN(+x.ProductId)) {
        return x.ProductId;
      } else if (x.ProductId?.id != null) {
        return x.ProductId.id;
      } else {
        return;
      }
    });
    ids = ids.filter((x) => x != null);
    if (ids.length === 0) {
      return;
    }
    this.connectionService.get(
      `${AppConfigService.settings.dataApiUrl}Product?filter=Id in (${ids.join(
        ','
      )})`,
      (response) => {
        const value = response.value as any[];
        this.relatedProducts = value.map((prod) => {
          return {
            id: prod.Id,
            name: prod.Name,
            sku: prod.Sku,
          };
        });
      }
    );
  }

  onRelatedProductsChange(products: Set<Product>) {
    this.catalogMode = 'edit';
    this.formGroup.get('type')?.setValue(this.tabIndex)
    if (!this.record || !this.record.Id) {
      const prodsToAdd: {
        ProductId: number | Product;
      }[] = [];
      Array.from(products).forEach((prod) => {
        if (prodsToAdd.find((x) => x.ProductId == prod.id) == null)
          prodsToAdd.push({
            ProductId: prod?.id ?? prod,
          });
      });
      this.formGroup.get('ProductCategories')?.setValue(prodsToAdd);
    } else {
      const categoryId = this.record.Id;
      const prodsToAdd: {
        CategoryId: any;
        ProductId: number | Product;
      }[] = [];
      Array.from(products).forEach((prod) => {
        if (prodsToAdd.find((x) => x.ProductId == prod.id) == null)
          prodsToAdd.push({
            CategoryId: categoryId,
            ProductId: prod?.id ?? prod,
          });
      });

      this.formGroup.get('ProductCategories')?.setValue(prodsToAdd);
    }

  }


  initTranslationGroup() {

    const translationFormGroup = this.formGroup.get(
      'Translations'
    ) as FormGroup;
    this.languages.forEach((lang) => {
      const control = translationFormGroup.get(lang.Code.toString());
      if (control == null) {
        translationFormGroup.addControl(
          lang.Code.toString(),
          new FormControl(this.record?.Translations[lang.Code.toString()] || '')
        );
      } else {
        control.setValue(this.record?.Translations[lang.Code.toString()] || '');
      }
    });
  }

  public get translationFormGroup(): FormGroup {
    return this.formGroup.get('Translations') as FormGroup;
  }

  static controls(mode: string) {
    const controlsToReturn: any = {};
    if (mode === 'edit') {
      controlsToReturn['Id'] = [null, []];
    }
    controlsToReturn['Name'] = [null, [Validators.required]];
    controlsToReturn['ParentId'] = [null, [Validators.required]];
    controlsToReturn['ProductCategories'] = [null, []];
    controlsToReturn['ClonedCategories'] = [null];
    controlsToReturn['AttributeValues'] = new FormGroup({});
    controlsToReturn['Translations'] = new FormGroup({});
    controlsToReturn['type'] = [null];
    return controlsToReturn;
  }


  //New
  tabIndex: string = '';
  filter: any;
  isFiltersCleared = false;

  receiveProducts(products: any) {
    this.relatedProducts = [...products]

  }

  receiveFilter(event: any) {
    this.filter = event;
  }

  onTabIndexChange(newTabIndex: string) {
    this.tabIndex = newTabIndex;
    // if (this.tabIndex === 'Manual') {
    //   this.relatedProducts = [];
    // }
    //localStorage.setItem('tabIndex', newTabIndex);
  }

  handleClearCondition() {
    this.isFiltersCleared = true;

    this.deleteAllRelatedProducts();

  }
  receiveProductIds(ids: any) {
    this.onRelatedProductsChange(ids);
  }
  loadingProduct = false;
  onLoadingChanged(loading: boolean) {
    this.loadingProduct = loading;
  }

  refrsh() {
    this.relatedProducts = [];
  }

  deleteAllRelatedProducts() {
    if (this.categoryId === 0) {
      return;
    }

    this.categoryService.selectAllCategoryProducts(this.categoryId).pipe(
      switchMap((productIds) => {
        if (!productIds || productIds.length === 0) {
          this.message.info('No products to delete.');
          return EMPTY;
        } else {

          return this.categoryService.bulkDeleteCategoryProducts(this.categoryId, productIds);
        }

      })
    ).subscribe({
      next: () => {
        this.message.success('Deleted successfully');
        this.relatedProducts = [];

      },
      error: () => {
        this.message.error('An error occurred. Please try again.');
      }
    });
  }

}
